import React from 'react';

import Row from '@/app/_components/container/Row';

import style from './FlexBox.module.scss';

interface FlexBoxProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
  className?: string;
}

const FlexBox: React.FC<FlexBoxProps> = ({ children, className, ...props }) => {
  const containerClass = className ? `${style.container} ${className}` : style.container;
  return (
    <Row className={containerClass} {...props}>
      {children}
    </Row>
  );
};

export default FlexBox;
